export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';
import type {BubbleList} from 'kpc';

type DemoItem = {
    key: number
    role: 'ai' | 'user'
    content: string
};

interface Props {
    status: string
    roles: Record<string, any>
    items: DemoItem[]
}

function createItem(index: number): DemoItem {
    return {
        key: index,
        role: index % 2 ? 'user' : 'ai',
        content: `第 ${index} 条消息：这里是 BubbleList 方法调用演示内容。`,
    };
}

function createRoles(): Props['roles'] {
    return {
        ai: {
            placement: 'start',
            avatar: true,
            roleName: 'AI 助手',
        },
        user: {
            placement: 'end',
            avatar: true,
            roleName: '我',
            variant: 'outlined',
        },
    };
}

function createState(): Props {
    return {
        status: '点击上方按钮查看方法效果',
        roles: createRoles(),
        items: Array.from({length: 12}).map((_, index) => createItem(index + 1)),
    };
}

export default class extends Component<Props> {
    static template = template;

    private listRef: BubbleList | null = null;

    static defaults() {
        return createState();
    }

    @bind
    scrollToTop() {
        this.listRef?.scrollToTop('smooth');
        this.set({
            status: '已调用 scrollToTop()',
        });
    }

    @bind
    scrollToSixth() {
        this.listRef?.scrollToKey(6, 'smooth');
        this.set({
            status: '已调用 scrollToKey(6, "smooth")，目标项会尽量贴近顶部',
        });
    }

    @bind
    scrollToBottom() {
        this.listRef?.scrollToBottom('smooth');
        this.set({
            status: '已调用 scrollToBottom()',
        });
    }

    @bind
    checkAtBottom() {
        const result = this.listRef?.isAtBottom();
        this.set({
            status: result ? '当前处于底部附近' : '当前不在底部附近',
        });
    }
}